// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip-31sJz","tooltip_recommend":"tooltip_recommend-2YswN","tooltip_withInfo":"tooltip_withInfo-Gugur","info":"info-2FyuM"};